import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigationHistory } from "../../contexts/NavigationHistoryContext";

/**
 * This component tracks location changes and updates the navigation history.
 * It should be placed inside the Router context.
 */
export function LocationTracker() {
  const location = useLocation();
  const { addToHistory } = useNavigationHistory();

  useEffect(() => {
    // Add current location (including search params) to history
    addToHistory(location.pathname, location.search);
  }, [location.pathname, location.search, addToHistory]);

  // This component doesn't render anything
  return null;
}

export default LocationTracker;
